import {
    GET_QR_CODE_REQUEST, GET_QR_CODE_SUCCESS, GET_QR_CODE_FAILURE, CLEAR_QR_CODE, SET_QR_GENERATED
} from '../actions/constants';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
    qrCodeData: null,
    qrCodeLoading: false,
    qrCodeError: null,
    qrGenerated: {},
};

const qrCodeReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_QR_CODE_REQUEST:
            return {
                ...state,
                qrCodeLoading: true,
                qrCodeError: null,
            };
        case GET_QR_CODE_SUCCESS:
            return {
                ...state,
                qrCodeLoading: false,
                qrCodeData: action.payload,
                qrCodeError: null,
            };
        case GET_QR_CODE_FAILURE:
            return {
                ...state,
                qrCodeLoading: false,
                qrCodeError: action.payload,
            };
        case SET_QR_GENERATED:
            return {
                ...state,
                qrGenerated: {
                    ...state.qrGenerated,
                    ...action.payload,
                },
            };
        case CLEAR_QR_CODE:
            return {
                ...state,
                qrCodeData: null,
                qrCodeLoading: false,
                qrCodeError: null,
            };
        default:
            return state;
    }
};

export default persistReducer(
    {
        key: 'qrCodeReducerKey',
        storage: storage,
        whitelist: ['qrGenerated'],
    },
    qrCodeReducer
);
